import { breakpoints } from 'theme/MuiThemeProvider/breakpoints';
import { customTheme } from 'theme/MuiThemeProvider/theme';

export const styles = {
  paper: {
    maxWidth: '500px',
    minWidth: '500px',
  },
  topContent: {
    display: 'inline-flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '16px',
  },
  content: {
    marginBottom: '16px',
    fontSize: '14px',
    color: customTheme.custom.black.B70,

    [`@media (max-width: ${breakpoints.tablet}px)`]: {
      marginBottom: '16px',
      width: 'fit-content',
    },
  },
  subTitle: {
    margin: '8px 0 16px',
    fontSize: '12px',
    lineHeight: '16px',
    fontWeight: 500,
    color: customTheme.custom.black.B100,
  },
  original: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '8px',
    padding: '4px 8px',
    backgroundColor: customTheme.palette.primary.P50,
    color: customTheme.custom.white,
    fontSize: '14px',
    fontWeight: 500,
    height: '32px',
    boxSizing: 'border-box',
  },
  actions: {
    display: 'flex',
    justifyContent: 'flex-end',
    margin: '0 -14px -8px 0',
  },
  amountField: {
    margin: 0,
  },
  amountFieldInput: {
    height: '21px',
  },
  closeButton: {
    minWidth: '80px',
    marginRight: '8px',
    color: customTheme.custom.black.B70,
  },
  removeButton: {
    minWidth: '80px',
    color: customTheme.custom.error,
  },
  confirmButton: {
    minWidth: '90px',
    color: customTheme.custom.success,
  },
};
